import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-10 px-4 bg-[#111827] border-t border-gray-800" data-id="element-155">
      <div className="max-w-3xl mx-auto" data-id="element-156">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-157">
          <div className="bg-gray-900 p-6 md:p-8 rounded-2xl shadow-xl border border-gray-800" data-id="element-158">
            <h3 className="text-2xl font-black text-white mb-4 border-b-2 border-[#8FF650] pb-2 inline-block" data-id="element-159">
              El problema que casi nadie nota
            </h3>

            <p className="text-lg mb-4 text-gray-300" data-id="element-160">
              La mayoría de las personas desperdicia entre{' '}
              <span className="font-black text-[#8FF650]" data-id="element-161">
                2 y 4 horas al día
              </span>
              .
            </p>

            <ul className="space-y-2 mb-6 text-base font-bold text-gray-400" data-id="element-162">
              <li className="flex items-center gap-2" data-id="element-163">❌ aprendizaje</li>
              <li className="flex items-center gap-2" data-id="element-164">
                ❌ crecimiento personal
              </li>
            </ul>

            <p className="text-lg font-bold mb-4 text-white" data-id="element-165">
              Las personas que crecen más rápido en la vida tienen algo en
              común:
            </p>
            <p className="text-xl font-black text-black mb-6 bg-[#8FF650] inline-block px-2 py-1 rounded-sm" data-id="element-166">
              Consumen mejores ideas.
            </p>

            <p className="text-base font-bold mb-3 text-white" data-id="element-167">
              Ideas que cambian:
            </p>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-6 text-base font-bold text-gray-300" data-id="element-168">
              <li className="flex items-center gap-2" data-id="element-169">● su forma de pensar</li>
              <li className="flex items-center gap-2" data-id="element-170">● su disciplina</li>
              <li className="flex items-center gap-2" data-id="element-171">
                ● su visión del dinero
              </li>
              <li className="flex items-center gap-2" data-id="element-172">● su mentalidad</li>
              <li className="flex items-center gap-2" data-id="element-173">● sus hábitos</li>
            </ul>

            <div className="bg-[#8FF650]/10 p-5 rounded-xl border-l-4 border-[#8FF650]" data-id="element-174">
              <p className="text-lg font-bold text-[#8FF650]" data-id="element-175">
                Pero hay un problema.
              </p>
              <p className="text-base text-gray-300 mt-1" data-id="element-176">
                Leer todos los libros que podrían ayudarte tomaría años.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}